const GET_ADDRESSES_COORDINATES = 'GET_ADDRESSES_COORDINATES';

export default GET_ADDRESSES_COORDINATES;
